export default __webpack_public_path__ + "static/media/ensvee-logo.ea97160e.svg";